/**
 * The Caply mark — one drawing, everywhere.
 *
 * Navy C, gold inner arc, arrow sweeping up through the mouth with its head
 * emerging top-right. This is the brand mark and the only version of it: the
 * app, the marketing site, the login card, the user guide and the Word
 * templates all render these exact paths.
 *
 * Size floor: the mark needs about 28px to read. Below that the arrow and the
 * gold arc crowd the C's counter and the whole thing muddies into a dark spot.
 * So every placement keeps at least 32px (44px in the sidebar, 80px on login).
 * The browser tab icon is the exception — 16px cannot hold this geometry, so
 * the favicon is the reversed mark on a navy tile, which survives on a tab
 * strip in both light and dark Chrome.
 *
 * tone="dark" flips the C and arrow to white for navy backgrounds (guide
 * covers, deck covers). The gold arc stays gold.
 */

const NAVY = '#132231';
const GOLD = '#b79b63';

export default function CaplyMark({ className = 'w-9 h-9', tone = 'light', title }) {
  const ink = tone === 'dark' ? '#ffffff' : NAVY;

  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      fill="none"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : 'true'}
    >
      {title ? <title>{title}</title> : null}
      {/* arrow sweep, drawn under the C so it passes behind it */}
      <path d="M 16 74 Q 40 60 62 42" stroke={ink} strokeWidth="7" strokeLinecap="round" />
      {/* the C */}
      <path
        d="M 69.5 22 A 34 34 0 1 0 69.5 78"
        stroke={ink}
        strokeWidth="12"
        strokeLinecap="round"
      />
      {/* gold inner arc, nested in the top-left of the counter */}
      <path d="M 46 28 A 22 22 0 0 0 28 54" stroke={GOLD} strokeWidth="6" strokeLinecap="round" />
      {/* arrowhead, last so it sits over everything */}
      <path d="M 72 34 L 57 36 L 67 48 Z" fill={ink} />
    </svg>
  );
}
